import {compareAsc} from 'date-fns'

export const isTokenValid = (exp: number) => {
  const expDate = new Date(exp * 1000)
  const now = new Date()
  return compareAsc(expDate, now) === 1
}
